'use client';

import { useEffect } from 'react';

let lockCount = 0;
let savedScrollY = 0;
let savedStyle: {
  position: string;
  top: string;
  width: string;
  overflow: string;
} | null = null;

export const useBodyScrollLock = (isOpen: boolean): void => {
  useEffect(() => {
    if (!isOpen) return;
    if (typeof document === 'undefined') return;

    const html = document.documentElement;

    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      savedStyle = {
        position: html.style.position,
        top: html.style.top,
        width: html.style.width,
        overflow: html.style.overflow,
      };
      html.style.position = 'fixed';
      html.style.top = `-${savedScrollY}px`;
      html.style.width = '100%';
      html.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0 && savedStyle) {
        html.style.position = savedStyle.position;
        html.style.top = savedStyle.top;
        html.style.width = savedStyle.width;
        html.style.overflow = savedStyle.overflow;
        window.scrollTo(0, savedScrollY);
        savedStyle = null;
      }
    };
  }, [isOpen]);
};
